export default __webpack_public_path__ + "images/56846be683350f50a40424d152079933-man2.jpg";